import {buttonEnum} from '../helper'
import MenuButtonParent from "./menu-button-parent";
import vrMenuTrackingToggle from "./vr-menu-tracking-toggle";
import VrMenu from "./vr-menu";

class VrButtonContainer extends THREE.Object3D {
    static instance;
    position;

    constructor() {
        super();
        if (!VrButtonContainer.instance) {
            VrButtonContainer.instance = this;
            MenuButtonParent.getInstance().add(this);
        }

        this.originalPosition= new THREE.Vector3(0, -1.2, -.5);
        this.stepMenuPosition= new THREE.Vector3(0, -1.125, -.5);
        this.position= new THREE.Vector3(0, -1.2, -.5);

        return VrButtonContainer.instance;
    }

    changeParent(parent) {
        if (!parent) {
            return;
        }

        parent.add(this);
    }

    setPositionOnStepMenu() {
        this.position = this.stepMenuPosition.clone();
    }

    setPositionToOriginal() {
        this.position = this.originalPosition.clone();
    }

    createMenuButton(buttonType){
        if( buttonType === buttonEnum.MENU_TOGGLE){
            return new vrMenuTrackingToggle(VrButtonContainer.getInstance());
        }
        else if ( buttonType === buttonEnum.MENU){
            return new VrMenu(VrButtonContainer.getInstance());
        }
    }

    static getInstance() {
        if (VrButtonContainer.instance) {
            return VrButtonContainer.instance;
        }

        return new VrButtonContainer();
    }
}

export default VrButtonContainer;

iq3Camera.addEventListener('change', ({position, orientation}) => {
    if (isVRModeEnabled() && mController.hasAnyVisibleContent() && !isMobileARModeEnabled()) {
        const vrButtonContainer = VrButtonContainer.getInstance();
        vrButtonContainer.lookAt(position);
    }
});
